// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__sDuIg","Label":"Input_Label__1paeR","InputElement":"Input_InputElement__3KAYM","Invalid":"Input_Invalid__1SJy3"};